import * as React from "react";
const SvgServerDatabase = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871v16.504h9.381v2.246l-1.5.002-1.5.002-.004.752-.002.75h7.508v-1.506H12.748v-2.246h9.381V1.871H12ZM3.38 3.38H20.62v5.99H3.38V6.375Zm2.996 2.246v1.498H8.717V5.625H7.545zm4.684 0v1.498h6.566V5.625h-3.283Zm-7.68 5.252H20.62v6H3.38v-3zm2.996 2.246v1.508H8.717v-1.508H7.545zm4.684 0v1.508h6.566v-1.508h-3.283z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgServerDatabase;
